import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export const EMOTORAD__PRODUCT_CATALOGUE__PARENT_MODEL_TEMPLATE_ID = "df487493-54cd-4a5e-8bcf-56a285fab72d" as Uuid;

export const EMOTORAD__PRODUCT_CATALOGUE__MODEL_TEMPLATE_ID = "05be7966-1f52-47fc-a36e-010cbdff9275" as Uuid;

export const EMOTORAD__PRODUCT_CATALOGUE__VARIANT_TEMPLATE_ID = "dc6147a3-ca39-4d61-80a2-704c9c3a9e87" as Uuid;

export const EMOTORAD__PRODUCT_CATALOGUE__COLOR_TEMPLATE_ID = "a6c92a8d-fa1b-4ecc-b348-d14d24d47366" as Uuid;

export const EMOTORAD__PRODUCT_CATALOGUE__PARENT_MODEL_NAME__COLUMN_ID = "33964611-7172-45a8-ac61-455da9f8c1e7" as Uuid;

export const EMOTORAD__PRODUCT_CATALOGUE__MODEL_NAME__COLUMN_ID = "f63fb855-0edb-412e-9bd6-2dd445b73dd6" as Uuid;

export const EMOTORAD__PRODUCT_CATALOGUE__VARIANT_NAME__COLUMN_ID = "866a4686-0fe6-4721-b50b-262a429377a2" as Uuid;

export const EMOTORAD__PRODUCT_CATALOGUE__COLOR_NAME__COLUMN_ID = "ec16634a-156b-48eb-9d32-1364f0b80f42" as Uuid;

export const EMOTORAD__PRODUCT_CATALOGUE__COLOR_HEX__COLUMN_ID = "ca51565f-ede4-4d1d-a3a8-444c3c0a8a43" as Uuid;

export const EMOTORAD__PRODUCT_CATALOGUE__PRICE_STARTING_FROM__COLUMN_ID = "fdaee29a-600f-4df1-b1e1-a95bf8c89550" as Uuid;

export const EMOTORAD__PRODUCT_CATALOGUE__DISCOUNTED_PRICE__COLUMN_ID = "55c2c158-21b2-4fd3-b5c1-347355dfed01" as Uuid;

export const EMOTORAD__PRODUCT_CATALOGUE__SKU_ID__COLUMN_ID = "77237221-ac24-431c-ba01-36f08e997f0f" as Uuid;

export enum EmotoradProductCatalogues {
    Product = "0bd5bde6-8216-4e01-81ac-c067fc350544",
    Variant = "d1353c45-2d6a-49ac-bb1f-68d0765f5e6b",
}
